<template>
  <el-dialog
    v-model="visible"
    width="775px"
    :close-on-click-modal="true"
    :show-close="false"
    class="material-upload-notice-modal"
    append-to-body
    @close="handleClose"
  >
    <div class="notice-container">
      <button type="button" class="notice-close" aria-label="关闭" @click="handleClose">
        <img :src="images.close3" alt="" />
      </button>

      <h2 class="notice-title">素材上传须知</h2>

      <div class="notice-body">
        <p class="notice-paragraph">
          1. ChaoVideo 2.0模型不支持直接上传含有真人人脸的参考图/视频。
        </p>
        <p class="notice-paragraph">
          2. 若参考图/视频不可避免包含人脸，建议先按以下方法处理图片，再使用 ChaoVideo 2.0
          系列模型生成视频。
        </p>

        <div class="notice-examples">
          <div class="example-item">
            <div class="example-image">
              <img :src="images.xuzhi001" alt="模糊面部" />
            </div>
            <span class="example-label">模糊面部</span>
          </div>
          <div class="example-item">
            <div class="example-image">
              <img :src="images.xuzhi002" alt="截掉面部" />
            </div>
            <span class="example-label">截掉面部</span>
          </div>
        </div>
        <p class="notice-paragraph">3.用 ChaoVideo 2.0 模型创作时，素材上传有这些小规则哦：</p>
        <ul class="notice-rules">
          <li>
            <span>✅ 参考素材：最多 9 张图 / 3 段视频 /3 段音频，总数不超过 12 个</span>
          </li>
          <li>
            <span>✅ 上传的参考视频总时长：不超过 15 秒</span>
          </li>
          <li>
            <span>✅ 上传的参考音频总时长：不超过 15 秒</span>
          </li>
        </ul>

        <div class="notice-tip">
          <span class="tip-icon">💡</span>
          <p>
            提示词小建议：中文控制在 500 字以内，英文不超过 1000
            词哦～字数过多容易让信息变分散，模型可能顾不上所有细节，导致视频里漏掉你想要的元素。
          </p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup lang="ts">
import { images } from '@/assets'
import { useModalStore } from '@/stores/modal'

const modalStore = useModalStore()

const visible = computed({
  get: () => modalStore.showMaterialUploadNoticeModal,
  set: (val) => {
    if (!val) modalStore.closeMaterialUploadNoticeModal()
  },
})

const handleClose = () => {
  modalStore.closeMaterialUploadNoticeModal()
}
</script>

<style lang="scss" scoped>
.notice-container {
  position: relative;
  padding: 4px 8px 8px;
}

.notice-close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;

  img {
    width: 24px;
    height: 24px;
  }
}

.notice-title {
  margin: 0 0 20px;
  font-size: var(--font-xxl);
  font-weight: 600;
  line-height: 1.4;
  color: var(--text-primary);
  text-align: center;
}

.notice-body {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 4px;
}

.notice-paragraph {
  margin: 0 0 12px;
  font-size: var(--font-md);
  line-height: 1.7;
  color: var(--text-hui);
}

.notice-examples {
  display: flex;
  gap: 16px;
  margin: 4px 0 20px;
}

.example-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 168px;
}

.example-image {
  width: 168px;
  height: 168px;
  overflow: hidden;
  border-radius: var(--radius-sm);
  background: #fff;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.example-label {
  font-size: var(--font-sm);
  line-height: 1.4;
  color: var(--text-hui);
}

.notice-rules {
  margin: 0 0 16px;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
    font-size: var(--font-md);
    line-height: 1.6;
    color: var(--text-hui);

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.rule-check {
  flex-shrink: 0;
  color: var(--text-green);
  font-weight: 700;
}

.notice-tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;

  .tip-icon {
    flex-shrink: 0;
    margin-top: 1px;
    font-size: 16px;
    line-height: 1.6;
  }

  p {
    margin: 0;
    font-size: var(--font-md);
    line-height: 1.7;
    color: var(--text-hui);
  }
}
</style>

<style lang="scss">
.el-dialog.material-upload-notice-modal {
  background: var(--bg-third) !important;
  border-radius: var(--radius-xl) !important;

  .el-dialog__header {
    display: none !important;
  }

  .el-dialog__body {
    padding: 24px !important;
    background-color: var(--bg-third) !important;
    border-radius: var(--radius-xl) !important;
  }
}
</style>
